import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, Tabs, Tab,
	FormControl, FormGroup
} from '@mui/material';
import { Page, Header, SelectField, Label, SearchBar, FiltersDrawer, FilesDropzone, Alert, FilePicker } from 'components';
import { enqueueSnackbar } from 'actions';
import { SetFormState, UploadExcelFile } from '../../actions/UploadModuleActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const FileUpload = (props) => {
	const { className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.uploadModuleReducer.formState);
	const userId = useSelector(state => state.session.user.id);

	const _onChangeInput = (event) => {
		if (event.target.files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
			if (event.target.files && event.target.files.length > 0) {
				const file = event.target.files[0];
				setFormState({
					...formState,
					values: {
						...formState.values,
						inputFilePath: file
					}
				});
			}
		} else {
			dispatch(enqueueSnackbar({ message: 'File type not supported', options: { variant: 'warning' } }));
		}
	};

	const _saveExcelFile = (event) => {
		if (formState.values.inputFilePath) {
			if (formState.values.inputFilePath.size > 50000000) {
				dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 50MB', options: { variant: 'warning' } }));
			} else if (formState.values.inputFilePath === '') {
				dispatch(enqueueSnackbar({ message: 'No file selected', options: { variant: 'Info' } }));
			} else {
				dispatch(UploadExcelFile(userId, formState.values.inputFilePath));
				dispatch(enqueueSnackbar({ message: 'File uploaded', options: { variant: 'info' } }));
			}
		}
	};

	return (
		<div className={classes.fields}>
			<br />
			<Grid container spacing={4}>
				<Grid item md={12} xs={12}>
					<Card>
						{/* <CardHeader
							title="Technology"
						/>
						<Divider /> */}
						<CardContent>
							{/* New row */}
							<Grid container spacing={3}>
								<Grid item md={6} xs={6}>
									<FilePicker
										placeholder="Please select a file to upload"
										accept=".xlsx"
										onChange={_onChangeInput}
										value={formState.values.inputFilePath?.name || ''}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<Button
										color="primary"
										onClick={_saveExcelFile}
										variant="contained"
									>
										Upload
									</Button>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

FileUpload.propTypes = {
	className: PropTypes.array.isRequired
};

export default FileUpload;
